import React from "react";

const RecentOrdersTable = ({
  activeTab,
  setActiveTab,
  userData,
  products,
  orderStats,
  orders = [],
}) => {
  const handleCancelOrder = async (orderId) => {
    try {
      const response = await fetch(
        `https://dehleze.shop/account/orders/${orderId}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            // Add Authorization header here if required
          },
          body: JSON.stringify({ order_status: "cancelled" }), // ✅ Correct field
        }
      );

      if (response.ok) {
        alert("Order status changed to 'cancelled' successfully.");
        // Optionally refresh the orders list or update state here
      } else {
        alert("Failed to update order status.");
      }
    } catch (error) {
      console.error("Cancel order error:", error);
      alert("An error occurred while updating the order status.");
    }
  };

  return (
    <div className="y-orders-container">
      <h2 className="y-orders-title">Recent Orders</h2>
      <div className="y-table-responsive">
        <table className="y-orders-table">
          <thead>
            <tr>
              <th className="y-table-header">Order#</th>
              <th className="y-table-header">Placed On</th>
              <th className="y-table-header">Items</th>
              <th className="y-table-header">Total</th>
              <th className="y-table-header">Status</th>
              {/* <th className="y-table-header">Action</th> */}
            </tr>
          </thead>
          <tbody>
            {orders
              .filter((order) => order.user === userData?.id) // ✅ Filter by user ID
              .sort((a, b) => new Date(b.placed_at) - new Date(a.placed_at))
              .map((order) => {
                const product = products.find(
                  (prod) => prod.id === order.product
                );

                return (
                  <tr key={order.id} className="y-table-row">
                    <td className="y-table-cell">{product?.id}</td>
                    <td className="y-table-cell">
                      {new Date(order.placed_at).toLocaleDateString()}
                    </td>
                    <td className="y-table-cell">
                      <img
                        src={product?.product_image}
                        alt="Item"
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "cover",
                          borderRadius: "6px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      />
                    </td>
                    <td className="y-table-cell">Rs {order?.total_price}</td>
                    <td className="y-table-cell">
                      {order?.order_status !== "cancelled" ? (
                        <button
                          onClick={() => handleCancelOrder(order.id)}
                          style={{
                            padding: "4px 10px",
                            backgroundColor: "#d9c436",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                            fontWeight: "500",
                            fontSize: "12px",
                            cursor: "pointer",
                            transition:
                              "background-color 0.3s ease, transform 0.2s ease",
                            boxShadow: "0 2px 6px rgba(253, 211, 24, 0.25)",
                          }}
                          onMouseOver={(e) => {
                            e.target.style.backgroundColor = "#d9363e";
                            e.target.style.transform = "scale(1.05)";
                          }}
                          onMouseOut={(e) => {
                            e.target.style.backgroundColor = "#ff4d4f";
                            e.target.style.transform = "scale(1)";
                          }}
                        >
                          Cancel Order
                        </button>
                      ) : (
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 8px",
                            backgroundColor: "#bfbfbf",
                            color: "#fff",
                            fontWeight: "500",
                            borderRadius: "4px",
                            fontSize: "12px",
                          }}
                        >
                          Cancelled
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentOrdersTable;
